/**
 * Geheime-code unlock — tijdelijke toegang (default 2 min) tot de geheime widgets
 * in de widget-bibliotheek. Per browser (localStorage), ephemeral.
 *
 * Flow: de geheime code (App.js) roept unlockSecret() aan → zet een vervaltijd en
 * dispatcht een window-event. Componenten luisteren via useSecretUnlock().
 */
import { useEffect, useState } from 'react';

const KEY = 'ffSecretUnlockUntil';
export const SECRET_EVENT = 'ff-secret-unlock';
export const SECRET_UNLOCK_MS = 120000; // 2 minuten

export function unlockSecret(ms = SECRET_UNLOCK_MS) {
  const until = Date.now() + ms;
  try { localStorage.setItem(KEY, String(until)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(SECRET_EVENT, { detail: { until } }));
  return until;
}

function unlockUntil() {
  try { return Number(localStorage.getItem(KEY)) || 0; } catch { return 0; }
}

export function isSecretUnlocked() {
  return unlockUntil() > Date.now();
}

// Reactieve hook: true zolang de unlock geldig is. Werkt bij op het event,
// een storage-wijziging (andere tab) en periodiek (om verval op te pikken).
export function useSecretUnlock() {
  const [unlocked, setUnlocked] = useState(() => isSecretUnlocked());
  useEffect(() => {
    const check = () => setUnlocked(isSecretUnlocked());
    check();
    const id = setInterval(check, 5000);
    window.addEventListener(SECRET_EVENT, check);
    window.addEventListener('storage', check);
    return () => {
      clearInterval(id);
      window.removeEventListener(SECRET_EVENT, check);
      window.removeEventListener('storage', check);
    };
  }, []);
  return unlocked;
}
